module.exports = __webpack_public_path__ + "img/Chris Elliott.c44b3cc8.jpg";